class IdentityApiSignOutProxy {
  constructor(config) {
    this.config = config;
  }
  static from(config) {
    return new IdentityApiSignOutProxy(config);
  }
  getUserId() {
    if (!this.config.identityApi.getUserId) {
      throw new Error(`SignOutProxy IdentityApi.getUserId is not implemented`);
    }
    return this.config.identityApi.getUserId();
  }
  getIdToken() {
    if (!this.config.identityApi.getIdToken) {
      throw new Error(`SignOutProxy IdentityApi.getIdToken is not implemented`);
    }
    return this.config.identityApi.getIdToken();
  }
  getProfile() {
    if (!this.config.identityApi.getProfile) {
      throw new Error(`SignOutProxy IdentityApi.getProfile is not implemented`);
    }
    return this.config.identityApi.getProfile();
  }
  getProfileInfo() {
    return this.config.identityApi.getProfileInfo();
  }
  getBackstageIdentity() {
    return this.config.identityApi.getBackstageIdentity();
  }
  getCredentials() {
    return this.config.identityApi.getCredentials();
  }
  signOut() {
    return this.config.signOut();
  }
}

export { IdentityApiSignOutProxy };
//# sourceMappingURL=IdentityApiSignOutProxy.esm.js.map
